import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "container" }

import { computed, onMounted, ref } from 'vue';
	import axios from 'axios';
	import functions from '@/use/functions';
	import { AnnualReviewCreditDetails, KnockoutModel, AlertModel } from '@/models/loans';
	import KnockoutsTable from '@/components/loan/annual-review/KnockoutsTable.vue';
	import AlertsTable from '@/components/loan/annual-review/AlertsTable.vue';
	import CreditReportViewerModal from '@/components/loan/annual-review/CreditReportViewerModal.vue';

	
export default /*@__PURE__*/_defineComponent({
  __name: 'CreditReportInformation',
  props: {
    loanId: {},
    annualReviewId: {},
    lenderId: {},
    productTypeId: {},
    programTypeId: {},
    creditPullTypeId: {},
    applicationTypeId: {}
  },
  setup(__props: any) {

	const props = __props;

	const isLoading = ref<boolean>(false);
	const viewingReport = ref(false);
	const knockouts = ref<KnockoutModel[]>([]);
	const alerts = ref<AlertModel[]>([]);
	const borrowerCreditPullTypeId = ref<number>(1);
	const coBorrowerCreditPullTypeId = ref<number>(1);
	const hasCreditDetails = computed(() => knockouts.value.length || alerts.value.length);

	const closeReportModal = () => (viewingReport.value = false);
	const openReportModal = () => {
		if (isLoading.value == true) {
			return;
		}

		viewingReport.value = true;
	};

	const fetchCreditDetailsAsync = async () => {
		isLoading.value = true;

		try {
			const response = await axios.post<AnnualReviewCreditDetails>(
				`/api/annualreview/${props.annualReviewId}/credit-details`,
				{
					lenderId: props.lenderId,
					programTypeId: props.programTypeId,
					productTypeId: props.productTypeId,
					creditPullTypeId: props.creditPullTypeId,
          			applicationTypeId: props.applicationTypeId
				}
			);

			knockouts.value = response.data.knockouts;
			alerts.value = response.data.alerts;
			borrowerCreditPullTypeId.value = response.data.borrowerCreditPullTypeId;
			coBorrowerCreditPullTypeId.value = response.data.coBorrowerCreditPullTypeId;
		} catch (error) {
			functions.openModal({
				title: 'Oops!',
				description: 'There was an issue getting the credit report details. Please try again later.'
			});
		} finally {
			isLoading.value = false;
		}
	};

	onMounted(async () => {
		await fetchCreditDetailsAsync();
	});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(KnockoutsTable, {
      loanId: __props.loanId,
      knockouts: knockouts.value,
      isLoading: isLoading.value,
      borrowerCreditPullTypeId: borrowerCreditPullTypeId.value,
      coBorrowerCreditPullTypeId: coBorrowerCreditPullTypeId.value
    }, null, 8, ["loanId", "knockouts", "isLoading", "borrowerCreditPullTypeId", "coBorrowerCreditPullTypeId"]),
    _createVNode(AlertsTable, {
      loanId: __props.loanId,
      alerts: alerts.value,
      isLoading: isLoading.value,
      borrowerCreditPullTypeId: borrowerCreditPullTypeId.value,
      coBorrowerCreditPullTypeId: coBorrowerCreditPullTypeId.value
    }, null, 8, ["loanId", "alerts", "isLoading", "borrowerCreditPullTypeId", "coBorrowerCreditPullTypeId"]),
    (hasCreditDetails.value)
      ? (_openBlock(), _createElementBlock("a", {
          key: 0,
          onClick: openReportModal
        }, " View Credit Report(s) "))
      : _createCommentVNode("", true),
    (viewingReport.value)
      ? (_openBlock(), _createBlock(CreditReportViewerModal, {
          key: 1,
          annualReviewId: __props.annualReviewId,
          creditPullTypeId: __props.creditPullTypeId,
          onClose: closeReportModal
        }, null, 8, ["annualReviewId", "creditPullTypeId"]))
      : _createCommentVNode("", true)
  ]))
}
}

})